import React, { useContext, useCallback } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import CashierApi from "../../utility/CashierApi";
import { useNavigate } from "react-router";
import { CustomerIdContext } from "../../context/CustomerIdProvider";

function DeleteCartItem({ itemId }) {
  const { deleteData } = CashierApi();
  const { selectedCustomerId } = useContext(CustomerIdContext);
  const queryClient = useQueryClient();

  const deleteCart = useMutation({
    mutationFn: (id) => deleteData("carts/delete/", id),
    retry: false,
    onMutate: async (newCart) => {
      await queryClient.cancelQueries("cart"); // Cancel any outgoing refetches

      const previousCartData = queryClient.getQueryData([
        "cart",
        selectedCustomerId,
      ]);

      queryClient.setQueryData(["cart", selectedCustomerId], (old) => {
        return [...old.filter((x) => x.id != newCart)];
      }); // Optimistically update the todos

      return { previousCartData };
    },
    onError: (error, newCart, context) => {
      queryClient.setQueryData(
        ["cart", selectedCustomerId],
        context.previousCartData
      );
    },

    onSettled: () => {
      const isCartUpdated = queryClient.getQueryData([
        "cart",
        selectedCustomerId,
      ]);
      if (!isCartUpdated) {
        queryClient.invalidateQueries(["cart", selectedCustomerId]);
      }
    },
  });

  const handleDelete = useCallback(() => {
    deleteCart.mutate(itemId);
  }, [deleteCart, itemId]);

  return (
    <div className="flex justify-center items-center w-full h-full">
      <div className=" p-1 bg-red-600 rounded-md cursor-pointer">
        <DeleteIcon
          sx={{ fontSize: "20px" }}
          onClick={!deleteCart.isPending ? handleDelete : undefined}
          className="text-white "
        />
      </div>
    </div>
  );
}

export default React.memo(DeleteCartItem);
